import React, { useEffect } from 'react';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import { AddCircle } from '@material-ui/icons';
import { useState } from 'react';
import TablePaginationActions from '../../../shared/table-pagination/TablePaginationActions';
import moment from 'moment';

const AppConfigurationList = ({ handleCreateApp, appConfigurationList, handleEdit, type }) => {
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [configurationList, setConfigurationList] = useState([]);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    setConfigurationList(appConfigurationList?.filter((config) => config?.type === type));
    setPage(0);
  }, [type, appConfigurationList]);

  return (
    <div className='container mt-4'>
      <div className='row mx-2 d-flex mt-4'>
        <div className='card shadow'>
          <div className='mt-4 mb-4 user-list-container'>
            <div className='row mx-2 d-flex'>
              <div className='col-md-6'></div>
              <div className='col-md-6  d-flex justify-content-end'>
                <Button
                  variant='contained'
                  color='primary'
                  size='large'
                  startIcon={<AddCircle />}
                  onClick={(e) => {
                    handleCreateApp();
                  }}
                  className='ms-5'
                >
                  Create
                </Button>
              </div>
            </div>
            <div className='row mx-2 d-flex mt-4'>
              <TableContainer>
                <Table className='list-table ' aria-label='simple table'>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Description</TableCell>
                      <TableCell>Updated Date</TableCell>
                      <TableCell>Updated Time</TableCell>
                      <TableCell>User Name</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(rowsPerPage === -1
                      ? configurationList
                      : configurationList?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                    )?.map((appItem) => {
                      return (
                        <TableRow
                          key={appItem?.id}
                          onClick={() => {
                            handleEdit(appItem);
                          }}
                        >
                          <TableCell className='ellipsisText'>{appItem?.name} </TableCell>
                          <TableCell className='ellipsisText'>{appItem?.description}</TableCell>
                          <TableCell>
                            {moment(appItem?.updatedAt * 1000).format('YYYY-MM-DD')}{' '}
                          </TableCell>
                          <TableCell>{moment(appItem?.updatedAt * 1000).format('HH:mm')}</TableCell>
                          <TableCell>{appItem?.userName}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                  <TableFooter>
                    <TableRow className='paginator'>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        count={configurationList?.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: { 'aria-label': 'Items per page' },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppConfigurationList;
